import { z } from "zod";
import { MyReportsDtoSchema } from "@/Schemas/Reports/MyReportsDto";
import { ReportExecutionHistoryParameterDtoSchema } from "@/Schemas/Reports/ReportExecutionHistoryParameterDto";

export const GetMyReportsExecutionHistoryDtoSchema = z.object({
    id: z.string(),
    executionStartTime: z.string().nullable(),
    executionEndTime: z.string().nullable(),
    executedByUserId: z.string(),
    expirationDate: z.string().nullable(),
    isTestingReport: z.boolean(),
    isRunningPeriodically: z.boolean().nullable(),
    wasRunAutomatically: z.boolean().nullable(),
    errorMessage: z.string().nullable(),
    report: MyReportsDtoSchema,
    reportExecutionHistoryParameters: z.array(ReportExecutionHistoryParameterDtoSchema)
});

export type GetMyReportsExecutionHistoryDto = z.infer<typeof GetMyReportsExecutionHistoryDtoSchema>;